import React from "react";
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

const StyledImageLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 600px;
  /* height: 80%; */
  overflow: hidden;
  object-fit: cover;
  position: relative;

  .layer {
    /* box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.2); */
    /* background: linear-gradient(
      to bottom left,
      ${(props) => props.theme.colors.gradienttwo},
      ${(props) => props.theme.colors.gradienttwo}
    );
    filter: brightness(0.8) contrast(1.3); */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  /* box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.2); */
  /* padding: 3em; */
  /* background-color: ${(props) => props.theme.colors.background}; */
`;

const StyledAlt = styled.figcaption`
  font-size: var(--fz-xs);
  color: ${(props) => props.theme.colors.descfont};
  font-weight: 300;
  margin-top: 0.5em;
  text-align: center;
  width: 100%;
  font-style: italic;
`;

const ImageLayout = (props: any) => {
  return (
    <StyledImageLayout>
      <GatsbyImage image={props?.src} alt={props?.alt} />
      <div className="layer"></div>
      <StyledAlt>{props?.alt}</StyledAlt>
    </StyledImageLayout>
  );
};

export default ImageLayout;
